<template>
  <v-dialog
    :value="value"
    persistent
    max-width="600px">
    <v-system-bar color="primary" dark dense>
      <span class="white--text pl-2">Добавление файла</span>
      <v-spacer></v-spacer>
      <v-icon @click="doCancel">mdi-close</v-icon>
    </v-system-bar>
    <v-card>
      <v-card-text class="black--text pb-1 pr-0">
        <v-row dense no-gutters class="align-center">
          <v-col cols="10">
            <v-file-input
              v-model="claimFile"
              show-size
              counter
              label="Имя файла"
            ></v-file-input>
          </v-col>
          <v-col cols="2" class="text-center">
            <v-btn
              :disabled="!claimFile"
              color="blue-grey"
              class="ma-2 white--text"
              fab
              small
              @click="uploadFile">
              <v-icon dark>
                mdi-cloud-upload
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import { CLM_ADD_FILE } from '@/store/actions/claims'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'claimAddFileDialog',
  data () {
    return {
      claimFile: null
    }
  },
  props: ['value', 'claim'],
  watch: {},
  computed: {},
  methods: {
    doCancel () {
      this.claimFile = null
      this.$emit('input', false)
    },
    uploadFile () {
      this.loading = true
      const formData = new FormData()
      formData.append('file', this.claimFile)
      formData.append('DOC_ID', this.claim.DOC_ID)
      if ('INST_ID' in this.claim) {
        formData.append('INST_ID', this.claim.INST_ID)
      }
      this.$store.dispatch(CLM_ADD_FILE, formData)
        .then(() => {
          this.$store.commit(UI_SNACKBAR, { color: 'green lighten-1', text: 'Файл загружен' })
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
        })
        .finally(() => {
          this.doCancel()
        })
    }
  },
  mounted: function () {
    console.log('claimAddFileDialog mounted')
  }

}
</script>
